import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { fetchProcessingAgencyOrganizedUnitConfigList, showProcessingAgencyOrganizedUnitConfigModal, deleteProcessingAgencyOrganizedUnitConfig } from '../../../actions/masters/processingAgencyOrganizedUnitConfig/processingAgencyOrganizedUnitConfig'
import ProcessingAgencyOrganizedUnitConfigMaster from '../../../components/masters/processingAgencyOrganizedUnitConfig/ProcessingAgencyOrganizedUnitConfigMaster'
import { fetchProcessingAgencyCommunicationServices } from '../../../actions/masters/processingAgencyCommunicationServices/processingAgencyCommunicationServices'
import { fetchOrganizedUnitsAll } from '../../../actions/combos/combos'

export function mapStateToProps (state) {
  return {
    ...state.processingAgencyOrganizedUnitConfig,
    combos: {
      organizedUnitsAllCombo: state.combos.organizedUnitsAllCombo,
      processingAgencyCommunicationServices: state.combos.processingAgencyCommunicationServices
    }
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchProcessingAgencyOrganizedUnitConfigList,
      showProcessingAgencyOrganizedUnitConfigModal,
      deleteProcessingAgencyOrganizedUnitConfig,
      fetchOrganizedUnitsAll,
      fetchProcessingAgencyCommunicationServices
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(ProcessingAgencyOrganizedUnitConfigMaster))
